// --- Active / Past order classification ---

// Payment statuses considered "in-progress" (money captured but order not done)
export const ACTIVE_PAYMENT_STATUSES = new Set([
  'pending', 'authorized', 'paid', 'partially_paid',
]);

// Shipping statuses that mean "not yet delivered"
export const ACTIVE_SHIPPING_STATUSES = new Set([
  'unfulfilled', 'pending', 'placed', 'shipped', 'partially_fulfilled',
]);

// Payment statuses that mean "order is done / terminal"
export const PAST_PAYMENT_STATUSES = new Set([
  'partially_refunded', 'refunded', 'declined',
]);

// Shipping statuses that mean "fully delivered"
export const DELIVERED_SHIPPING_STATUSES = new Set([
  'fulfilled', 'delivered',
]);

// --- Progress stepper ---

export interface OrderStep {
  label: string;
  description: string;
}

export const ORDER_STEPS: OrderStep[] = [
  { label: 'Order Created', description: 'Your order has been received.' },
  { label: 'Payment Confirmed', description: 'Payment has been processed.' },
  { label: 'Shipped', description: 'Your order has been shipped.' },
  { label: 'In Transit', description: 'Your package is on the way.' },
  { label: 'Delivered', description: 'Your order has been delivered.' },
];

// --- Status badge ---

export type BadgeVariant = 'success' | 'error' | 'info' | 'warning';

export interface StatusBadgeInfo {
  label: string;
  variant: BadgeVariant;
}

export const BADGE_COLORS: Record<BadgeVariant, { bg: string; fg: string }> = {
  success: { bg: 'rgba(47, 128, 106, 0.1)', fg: '#2f806a' },
  error: { bg: 'rgba(197, 48, 48, 0.1)', fg: '#c53030' },
  info: { bg: 'rgba(10, 96, 155, 0.1)', fg: '#0a609b' },
  warning: { bg: 'rgba(200, 170, 50, 0.1)', fg: '#a08520' },
};

// --- Modify-order accordion ---

export interface ModifyOption {
  id: string;
  label: string;
  icon: string;
}

export const MODIFY_OPTIONS: ModifyOption[] = [
  { id: 'change_color_size', label: 'Change Size & Color', icon: 'repeat' },
  { id: 'remove_items', label: 'Remove Items', icon: 'trash-2' },
  { id: 'billing_inquiry', label: 'Billing Inquiry / Dispute', icon: 'credit-card' },
];

// --- Pagination ---

export const MAX_ACTIVE_PER_PAGE = 3;
export const MAX_PAST_PER_PAGE = 5;
export const MAX_ORDERS_PER_PAGE = MAX_ACTIVE_PER_PAGE + MAX_PAST_PER_PAGE;
